import { render, staticRenderFns } from "./SettingHeader.vue?vue&type=template&id=3fd5166e&scoped=true&"
import script from "./SettingHeader.vue?vue&type=script&lang=js&"
export * from "./SettingHeader.vue?vue&type=script&lang=js&"
import style0 from "./SettingHeader.vue?vue&type=style&index=0&id=3fd5166e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd5166e",
  null
  
)

export default component.exports